// extracted by mini-css-extract-plugin
export default {"content":"MaintenancePage_content__gdv0x","page":"MaintenancePage_page__aaPsC","gap-8":"MaintenancePage_gap-8__irT3K"};